<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{ item.mainComplainNumber }}</div>
        </div>
        <!-- <div class="receivingAgency border_bottom">
                    <div class="left">审核人</div>
                    <div class="right">{{checkName}}</div>
                    <div class="right">我再操作机构机构名称，机构类型，机构测试，给师傅开始</div>
                </div> -->
      </div>
      <!-- <div class="uploadBox">
              <upload :imgUrl="imgUrl"></upload>
            </div> -->
      <div class="origin">
        <div class="left">审核人</div>
        <div class="right">
          {{ checkPerson.depts[0].orgName }}-{{ checkPerson.userInfo.name }}
        </div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button @click="getAccept" type="primary">提交</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../../../service/modules/complaintApis";
import util from "../../../../utils/common";
import upload from "@/components/uploadCopy";
export default {
  components: {
    upload,
  },
  data() {
    return {
      checkPerson:
        this.$store.state.complaint.userInfo ||
        util.getJsonLocal("userInfoComplaint"),
      orderNum: this.$router.currentRoute.query.orderNum,
      item: util.getJsonLocal("item"),
      flag: false,
      imgUrl: [],
      // isShowBtn: false
      // isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
    };
  },
  mounted() {
    this.$on("fileUploadData", (val) => {
      this.imgUrl = val;
    });
  },
  created() {},
  methods: {
    getAccept() {
      let params = {
        id: this.item.id,
        reportContent: "",
      };
      // this.isShowBtn = true;
      if (this.flag === false) {
        this.flag = true;
        api.worker.reportAgree(params).then((res) => {
          console.log(res);
          if (res.ret === 0) {
            this.$Toast("上报审核通过");
            if (
              localStorage.getItem("fromPath") &&
              localStorage.getItem("fromPath") == "home"
            ) {
              setTimeout(() => {
                localStorage.removeItem("fromPath");
                yyn.invokeJSB("closeWindow");
              }, 1500);
            } else {
              this.$router.go(-2);
            }

            // this.isShowBtn = false;
            // if(!this.isback){
            //       this.$router.go(-2);
            // }else{
            //     this.$router.back();
            //     this.$set(this.itemList,'btns',[]);
            //     util.setJsonLocal('item',this.itemList);
            // }
            // this.$router.go(-2);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .uploadBox {
      margin-top: 20px;
    }
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .receivingAgency,
      .acceptedLaborNumber,
      .inadmissibleReason {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
          // overflow: hidden;
          // text-overflow:ellipsis;
          // white-space: nowrap;
        }
      }
      .border_bottom {
        border-bottom: 1px solid #eee;
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
      .inadmissibleReason {
        .right {
          color: #ddd;
        }
      }
    }
    .origin {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 0;
      border-bottom: 1px solid #eee;
      .left {
        width: 50%;
        font-size: 14px;
        color: #aaa;
      }
      .right {
        width: 50%;
        font-size: 14px;
        color: #aaa;
        line-height: 1.3em;
        text-align: right;
      }
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
        margin-top: 10px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
  }
}
</style>
